var _g, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYourIdea(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 150,
    viewBox: "0 0 128 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.0056 24C62.4288 24 60.8177 24.1371 59.2067 24.4799C49.746 26.2966 42.2049 33.9406 40.4225 43.4012C38.7771 52.3477 42.0678 60.5744 48.0321 65.8874C49.5061 67.19 50.2945 69.0067 50.2945 70.9263V78.8444C50.2945 82.615 53.3795 85.7 57.15 85.7H58.1098C59.3095 87.7567 61.469 89.1278 64.0056 89.1278C66.5421 89.1278 68.7359 87.7567 69.9013 85.7H70.8611C74.6317 85.7 77.7167 82.615 77.7167 78.8444V70.9263C77.7167 69.041 78.4708 67.19 79.9104 65.9217C84.8807 61.5342 88 55.1242 88 47.9944C88 34.7289 77.2711 24 64.0056 24ZM70.8611 71.9889H57.15V68.5611H70.8611V71.9889ZM57.15 78.8444V75.4167H70.8611V78.8444H57.15ZM75.3515 60.8143C75.043 61.0885 74.8031 61.4313 74.5288 61.7055H53.448C53.1738 61.397 52.9338 61.0543 52.6253 60.78C48.1007 56.7353 46.0783 50.7024 47.1752 44.6695C48.4092 38.0196 53.8936 32.5009 60.5092 31.1983C61.6747 30.9584 62.8401 30.8556 64.0056 30.8556C73.4662 30.8556 81.1444 38.5338 81.1444 47.9944C81.1444 52.8962 79.0535 57.5579 75.3515 60.8143Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7193 51.4219H62.2915V61.7052H65.7193V51.4219Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4506 44.1329L56.0269 46.5566L63.2982 53.828L65.722 51.4042L58.4506 44.1329Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2947 51.4385L64.7185 53.8623L71.9898 46.591L69.5661 44.1672L62.2947 51.4385Z",
    fill: "currentColor"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 1.5,
    width: 105,
    height: 110.128,
    rx: 6.5,
    stroke: "#7367FF",
    strokeWidth: 3,
    strokeDasharray: "6 6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 4,
    width: 128,
    height: 145.128,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.49079 0 0 0 0 0.420104 0 0 0 0 0.925 0 0 0 0.61 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 58.5611,
    y1: -12.9626,
    x2: 58.5612,
    y2: 139.053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B48D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6784FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYourIdea);
export default __webpack_public_path__ + "static/media/YourIdea.8c59510a2712a60cd68e7f6b42fe1e7a.svg";
export { ForwardRef as ReactComponent };